angular.module('logbook')
.service('tag-ancestor-resolver', ['$http', '$q',
   function($http, $q) {
      var service = {
          cache: {},
          resolveArgument: function(tag, logId, argType, retrieveValues, names, ids)
          {
              var cacheKey = '__byname__' + logId + ' ' + tag;
              if( service.cache[cacheKey] )
                  tag = service.cache[cacheKey];
              
              if( typeof(tag) == 'object' )
              {
                  ids[argType] = tag.id;
                  names[argType] = tag.stringValue;
              }
              else
              {
                  retrieveValues.push(tag);
                  names[argType] = tag;
              }
          },
          retrieveTagValues: function(retrieveValues, logId, tag, ancestorParent, ids)
          {
             return $http.get('/api/tagValues', {
                params: {
                    "log": logId,
                    "stringValue": retrieveValues
                }
            }).then(function(tagResults) {
                tagResults.data._embedded.tagValues.forEach(function( tv ) {
                    service.cache['__byname__' + logId + ' ' + tv.stringValue] = tv;
                    if( ids && !ids['tag'] &&  tv.stringValue.toLowerCase() == tag.toLowerCase() )
                        ids['tag'] = tv.id;
                    else if( ancestorParent && !ids['ancestorParent'] && tv.stringValue.toLowerCase() == ancestorParent.toLowerCase())
                        ids['ancestorParent'] = tv.id;
                });
                return tagResults;
            });
          },
          resolveTagAncestor: function(tag, ancestorParent, logId)
          {
              var deferred = $q.defer();
              var retrieveValues = [], ids = {}, names = {};
              
              service.resolveArgument(tag, logId, 'tag', retrieveValues, names, ids);
              service.resolveArgument(ancestorParent, logId, 'ancestorParent', retrieveValues, names, ids);
              
              var cacheKey = '' + logId + ' ' + names['tag'] + ' ' + names['ancestorParent'];
              if( !tag || !ancestorParent )
              {
                 deferred.resolve();
              }
              else if( service.cache[cacheKey] )
              {
                  deferred.resolve(service.cache[cacheKey]);
              }
              else
              {
                 var inputDeferred = $q.defer();
                 if( retrieveValues.length > 0 )
                 {
                    service.retrieveTagValues(retrieveValues, logId, tag, ancestorParent, ids).then(function(results) {
                       inputDeferred.resolve(results);
                    });
                 }
                 else
                     inputDeferred.resolve();
                 
                 inputDeferred.promise.then(function(tagResults) {
                     if( !ids['tag'] || !ids['ancestorParent'] )
                      {
                         deferred.resolve(null);
                         return;
                      }
                     $http.get('/api/tagValues', {
                         params: {
                             'log': logId,
                             'parentDepthSpec': [ids['ancestorParent'], 1],
                             'isAncestorOf': ids['tag']
                         }
                     }).then(function(result) {
                         var ancestors = result.data.page.totalElements >= 1 
                            ? result.data._embedded.tagValues
                            : null;
                         if( ancestors )
                         {
                             service.cache[cacheKey] = ancestors;
                             ancestors.forEach(function(ancestor) {
                                 service.cache['__byname__' + logId + ' ' + ancestor.stringValue] = ancestor;
                             });
                         }
                         deferred.resolve(ancestors)
                     });
                 })
              }
              return deferred.promise;
          },
          getByName: function(logId, name)
          {
              return service.cache['__byname__' + logId + ' ' + name];
          }
      };
      
      return service;
}]);